export default __webpack_public_path__ + "static/media/eth.6e1743e3.png";